// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2hYyA","footer":"Form_footer__1CKKt"};